module.exports = __webpack_public_path__ + "img/theft_detection.9a0efcc0.png";